<template>
  <div class="col-12 col-md-4 col-xl-2">
    <div>
      <json-viewer :value="data"></json-viewer>
    </div>
    <l-button
      wide
      type="primary"
      class="btn-filter shadow-sm"
      style="margin-top: 30px"
      @click="send"
    >
      {{ $t('common_words.send') }}
    </l-button>
  </div>
</template>
<script>
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
export default {
  data() {
    return {
      data: [],
    };
  },
  methods: {
    send() {
      Axios.getMasters('irrigation/notification/sendEmail/America-Bogota')
        .then((response) => {
          this.data = response.data;
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });
    },
  },
};
</script>
